
import store from '../../config/store'
import { mapActions, mapGetters } from 'vuex'
import { formatPrice } from '../../helpers/filters/filter'

export default {
  components: {
    'component-alert': () => import(/* webpackChunkName: "components" */ '@/common/components/Alert.vue'),
    'component-button': () => import(/* webpackChunkName: "components" */ '@/common/components//Button.vue'),
    'datepicker': () => import(/* webpackChunkName: "components" */ '@/common/components/Datepicker.vue'),
  },

  data: () => ({
    store,
    account: store.data.user.account,
    values: [],
    disabled: {
      to: new Date()
    },
    execution_date: new Date(),
    selectedIndex: null
  }),

  computed: {
    ...mapGetters([
      'accounts',
      'multipleTransfers'
    ]),

    numberOfTransfers () {
      return this.values.length
    },

    selectedTransfers () {
      return this.values.filter(value => value.transfer.checked)
    },

    numberOfSelectedTransfers () {
      return this.selectedTransfers.length
    },

    getTotalLabel () {
      return this.numberOfSelectedTransfers ? this.$i18n.tc('form.multiple_transfers.total', this.numberOfSelectedTransfers, { numberOfSelectedTransfers: this.numberOfSelectedTransfers }) : this.$i18n.t('form.multiple_transfers.none_selected')
    },

    totalAmount () {
      var totalAmount = 0
      for (var i = 0; i < this.numberOfSelectedTransfers; i++) {
        totalAmount += parseFloat(this.selectedTransfers[i].transfer.amount)
      }
      return totalAmount
    },

    hasTransferChecked () {
      return this.values.some(value => value.transfer.checked)
    }

  },
  watch: {
    'store.data.user.account.uuid': function () {
      this.$router.push('/transfers')
    },

    'execution_date': function () {
      for (let i = 0; i < this.values.length; i++) {
        this.values[i].transfer.execution_date = this.execution_date
      }
    }
  },

  mounted () {
    this.values = [ ...this.multipleTransfers ]
    for (let i = 0; i < this.values.length; i++) {
      this.values[i].id = i
      this.$set(this.values[i].transfer, 'checked', true)
      this.$set(this.values[i].transfer, 'documents', [])
      this.$set(this.values[i].transfer, 'execution_date', this.execution_date)
      if (this.values[i].beneficiary.id === null) {
        this.values[i].transfer.checked = true //un virement ayant un bénéficiaire inconnu peut etre executé dans le cas LBO, mettre a false sinon
      }
    }

    this.$bus.$on('on-edit-transfers-success', this.editTransfers)
    this.$bus.$on('beneficiary-save-success', this.onBeneficiarySaved)
    this.$bus.$on('beneficiary-update-success', this.onBeneficiarySaved)
    this.$bus.$on('local-file-added', this.onFilesAttached)
    this.$bus.$on('password-checked', this.submitAllTransfers)
  },

  destroyed () {
    this.$bus.$off('on-edit-transfers-success', this.editTransfers)
    this.$bus.$off('beneficiary-save-success', this.onBeneficiarySaved)
    this.$bus.$off('beneficiary-update-success', this.onBeneficiarySaved)
    this.$bus.$off('local-file-added', this.onFilesAttached)
    this.$bus.$off('password-checked', this.submitAllTransfers)
  },

  methods: {
    ...mapActions([
      'createMultipleTransfers',
      'sendMultipleTransfers'
    ]),

    checkPassword () {
      this.showModal({
        childVue: 'check-password',
        wrapperClass: 'modal modal--xs',
        dataModel: {},
        blockLeaveBackground: true
      })
    },

    submitAllTransfers () {
      this.showModal({
        childVue: 'wait',
        wrapperClass: 'loading modal-wait',
        dataModel: {
          title: this.$i18n.t('modal.wait.title'),
          content: this.$i18n.t('modal.wait.content'),
        },
        blockLeaveBackground: true
      })
      const values = this.values.filter(value => value.transfer.checked)
      this.createMultipleTransfers(values).then(() => {
        this.onCreateSuccess()
      })
    },

    onCreateSuccess () {
      this.showBanner('success', this.$i18n.t('banner.success.transfers.create'))
      this.$router.push('/transfers')
    },

    onClickAttachment (e) {
      e.stopPropagation()
    },

    handleDocuments (value, index) {
      if (value.transfer.documents && value.transfer.documents.length) {
        this.showFileViewer(value.transfer)
      } else {
        this.addFiles(index)
      }
    },

    addFiles (index) {
      this.selectedIndex = index
      this.showModal({
        childVue: 'join-document',
        wrapperClass: 'modal modal--md',
        dataModel: {
          isLocal: true,
          multipleFiles: true
        },
        autoQueue: false
      })
    },

    onFilesAttached (files) {
      this.values[this.selectedIndex].transfer.documents = files
      this.selectedIndex = null
    },

    onClick (index, setEmail = false) {
      const value = this.values[index]
      if (value.beneficiary !== null) {
        this.showSidePanel({
          childVue: 'edit-multiple-transfer',
          dataModel: {
            index,
            values: this.values,
            setEmail
          },
          wrapperClass: 'sidepanel--xl',
          backgroundOverlay: true
        })
      }
    },

    onAddBeneficiary (index) {
      this.selectedIndex = index
      const value = this.values[index]
      this.showSidePanel({
        childVue: 'new-beneficiary',
        dataModel: {
          beneficiary: value.beneficiary
        },
        wrapperClass: 'sidepanel--xl',
        backgroundOverlay: true,
        closeButton: false
      })
    },

    editTransfers (newValues) {
      newValues.forEach(newValue => {
        this.values = this.values.map(value => value.id === newValue.id ? newValue : value)
      })
    },

    getTooltipMessageDocument (index) {
      return this.values[index].transfer.documents && this.values[index].transfer.documents.length ? 'tooltip.show_files' : 'tooltip.attach_files'
    },

    getTooltipMessageNotifications (index) {
      return this.values[index].beneficiary.email ? 'tooltip.send_email' : 'tooltip.add_email'
    },

    isUnknownBeneficiary (index) {
      return this.values[index].beneficiary.id === null && false //un virement ayant un bénéficiaire inconnu peut etre executé dans le cas LBO, supprimer false sinon
    },

    onBeneficiarySaved (response) {
      this.values[this.selectedIndex].beneficiary = response
      this.values[this.selectedIndex].checked = true
      this.selectedIndex = null
      this.hideSidePanel()
    },

    formattedIban (value) {
      return value.beneficiary.account_number_formatted || value.beneficiary.iban
    }

  }
}
